import { View } from 'react-native';

import { Stack } from '@/components/layout';
import { Button, SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type NotificationEmptyStateProps = {
  onSettings: () => void;
};

const strings = STRINGS.guardian.notifications;

export function NotificationEmptyState({ onSettings }: NotificationEmptyStateProps) {
  const { scale } = useScaling();
  const styles = useStyles();
  const iconSize = scale(100);

  return (
    <Stack flex={1} align="center" justify="center" gap={scale(16)} style={styles.container}>
      <View style={{ width: iconSize, height: iconSize }}>
        <SvgIcon
          name="IcNotificationEmptyBackground"
          width={iconSize}
          height={iconSize}
          style={styles.iconLayer}
        />
        <SvgIcon
          name="IcNotificationEmpty"
          width={iconSize * 0.68}
          height={iconSize * 0.68}
          style={styles.bell}
        />
      </View>
      <Text variant="Font Guardian App/Heading/Heading H6 18px" style={styles.title}>
        {strings.empty.title}
      </Text>
      <Text variant="Font Guardian App/Subtitle/Subtitle 12 Regular" style={styles.description}>
        {strings.empty.description}
      </Text>
      <Button variant="ghost" onPress={onSettings} style={styles.button}>
        <Button.Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
          style={styles.buttonText}>
          {strings.empty.action}
        </Button.Text>
      </Button>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  container: {
    minHeight: 0,
    paddingHorizontal: scale(20),
    paddingVertical: scale(16),
  },
  iconLayer: { position: 'absolute' },
  bell: { position: 'absolute', left: '16%', top: '16%' },
  title: { color: colors['10'], textAlign: 'center' },
  description: { color: colors['10'], textAlign: 'center', maxWidth: scale(228) },
  button: {
    width: scale(180),
    height: scale(40),
    minHeight: scale(40),
    padding: scale(10),
    borderRadius: scale(12),
    backgroundColor: guardianColors['Main/10'],
  },
  buttonText: { color: guardianColors['Main/Main'] },
}));
